import cssVariables from "@/config/cssVariables";
import mapbox from "@/config/mapbox";

export default function getMapboxRouteLayer(geometry, lineWidth = mapbox.defaultMapRouteLineWidth) {
  return {
    id: 'route',
    type: 'line',
    source: {
      type: 'geojson',
      data: {
        type: 'Feature',
        properties: {},
        geometry
      }
    },
    layout: {
      'line-join': 'round',
      'line-cap': 'round'
    },
    paint: {
      'line-color': cssVariables["app-primary-accent-color"],
      'line-width': lineWidth
    }
  }
}